import type { MetaFunction } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';
import parseFrontMatter from 'front-matter';
import * as React from 'react';
import Markdown from '~/components/shared/Markdown';
import { readMarkdown } from '~/services/markdown.server';
import { getModifiedTimeToString } from '~/utils/common.server';
import type { SitemapHandle } from '~/utils/sitemap.server';

export const meta: MetaFunction = () => ({
  title: 'SwagCharm | Privacy Policy',
  description: 'SwagCharm Privacy Policy',
});

export const handle: SitemapHandle = {
  getSitemapEntries: (path) => ({
    route: path,
    lastmod: getModifiedTimeToString(__filename),
    changefreq: 'daily',
    priority: 0.6,
  }),
};

export async function loader() {
  const md = await readMarkdown('privacy.md');
  if (!md) {
    throw new Response('Not Found', { status: 404 });
  }
  // "attributes" contains the parsed frontmatter
  // "body" contains the Markdown string without the frontmatter
  const { attributes, body } = parseFrontMatter(md);
  return { attributes, body };
}

const Privacy: React.FC = () => {
  const { attributes, body } = useLoaderData();
  return <Markdown attributes={attributes} body={body}></Markdown>;
};

export default Privacy;
